import React, { useState, useEffect } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { modalAction, modalDeleteAction } from '../../redux/reducers/Modal';
import { Pagination, PaginationItem, Grid } from '@mui/material';
import styled from '@mui/material/styles/styled';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import moment from 'moment';
import 'moment/locale/es';

const PaginationGrid = styled(Grid)(({ theme }) => `
    ul{
        justify-content: end
    }

    button:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)

const PaginationItemStyled = styled(PaginationItem)(({ theme }) => `
    svg{
        color: #000;
    }

    button:hover, svg:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)


function createData(id, room, product, amount, unitPrice, total, hour) {
  return { id, room, product, amount, unitPrice, total, hour };
}

const rows = [
  createData(1, 'Suite', 'Gaseosa Coca-Cola (1 Litro)', 2, 3.5, 7, moment().format('DD/MM/YYY HH:mm:ss')),
  createData(2, 'Suite', 'Galleta - Festival (350g)', 3, 2, 6, moment().format('DD/MM/YYY HH:mm:ss')),
  createData(3, 'Suite', 'Pizza mediana (400g)', 1, 12, 12, moment().format('DD/MM/YYY HH:mm:ss')),
];


const ServicesReport = () => {

    const [ clients, setClients ] = useState([]);
    const [ paginations, setPaginations ] = useState(0);
    const [ initResult, setInitResult ] = useState(0);
    const [ endResult, setEndResult ] = useState(10);
    const [ totalProductPrice, setTotalProductPrice ] = useState(0);
    const searchData = useSelector( state => state.Search.data );

    const [page, setPage] = React.useState(1);
    const handleChange = (event, value) => {
        if( page < value ){
            // aumentar
            setInitResult(initResult+10);
            setEndResult(endResult+10);
        }else{
            // disminuir
            setInitResult(initResult-10);
            setEndResult(endResult-10);
        }
        setPage(value);
    };

    useEffect( () => {
        setClients(rows);

        setPaginations(Math.ceil(rows.length/10))
    },[searchData, initResult, endResult] );

    useEffect( () => {
        let price = 0;
        rows.map( product => {
            price = price + product.total;
            setTotalProductPrice(price);
        } )
    },[] );

    const dispatch = useDispatch();
    const [ showModal, setShowModal ] = useState(false);
    const [ showDeleteModal, setShowDeleteModal ] = useState(false);
    const [ modalForm, setModalForm ] = useState('');
    const [ deleteModal, setDeleteModal ] = useState('');
    const modalStatus = useSelector( state => state.Modal.modalState );
    const deleteModalStatus = useSelector( state => state.Modal.deleteModalState );

    useEffect( () => {
        setShowModal(modalStatus);
      }, [modalStatus] );
    
    useEffect( () => {
        setShowDeleteModal(deleteModalStatus);
      }, [deleteModalStatus] );

    const editClient = () => {
        setDeleteModal('');
        dispatch(modalAction());
        setModalForm('editClient');
    }

    const deleteClient = () => {
        setModalForm('');
        dispatch(modalDeleteAction());
        setDeleteModal('client');
    }

  return (
    <>
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Habitación</TableCell>
                    <TableCell>Producto</TableCell>
                    <TableCell>Cantidad</TableCell>
                    <TableCell>Precio Unitario</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell align="center">Hora</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {clients.map((row) => (
                    <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">{row.id.substring(0, 5)}</TableCell>
                      <TableCell>{row.room}</TableCell>
                      <TableCell>{row.product}</TableCell>
                      <TableCell>{row.amount}</TableCell>
                      <TableCell>{row.unitPrice}</TableCell>
                      <TableCell>{row.total}</TableCell>
                      <TableCell align="center">{row.hour}</TableCell>
                    </TableRow>
                ))}
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell>Total: ${totalProductPrice}</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

        <Grid container sx={{ justifyContent: 'end', textAlign: 'end', mt: 2 }}>
            <PaginationGrid item xs={12}>
                <Pagination
                    count={paginations}
                    onChange={handleChange}
                    renderItem={(item) => (
                        <PaginationItemStyled
                        components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                        />
                    )}
                />
            </PaginationGrid>
        </Grid>
    </>
  )
}

export default ServicesReport